import PropTypes from 'prop-types'
import { iconSizes } from '../icons-sizes'
import { SvgIconComponent } from '../styledComponents'

export function TaskStatusOpen ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5 25C20.1274 25 25.5 19.6274 25.5 13C25.5 6.37258 20.1274 1 13.5 1C6.87258 1 1.5 6.37258 1.5 13C1.5 19.6274 6.87258 25 13.5 25Z"
        stroke="#787887"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 13.3125L12.0386 16.4063L18 10.5"
        stroke="#EDEDF1"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TaskStatusOpenOverdue ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z"
        fill="white"
        stroke="#D64949"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 7.10327C13.7364 7.10327 14.3333 7.70021 14.3333 8.43656V13.5158C14.3333 14.2522 13.7364 14.8491 13 14.8491C12.2637 14.8491 11.6667 14.2522 11.6667 13.5158V8.43656C11.6667 7.70021 12.2637 7.10327 13 7.10327Z"
        fill="#D64949"
      />
      <mask id="path-3-inside-1_8906_6077" fill="white">
        <path d="M13.0062 15.8491C13.2135 15.8491 13.4084 15.8908 13.5908 15.974C13.7816 16.0489 13.9432 16.1572 14.0759 16.2988C14.2169 16.432 14.3247 16.5943 14.3993 16.7859C14.4823 16.9691 14.5237 17.1647 14.5237 17.3729C14.5237 17.5728 14.4823 17.7643 14.3993 17.9475C14.3247 18.1306 14.2169 18.293 14.0759 18.4346C13.9432 18.5761 13.7816 18.6885 13.5908 18.7718C13.4084 18.8551 13.2135 18.8967 13.0062 18.8967C12.8072 18.8967 12.6123 18.8551 12.4216 18.7718C12.2391 18.6968 12.0774 18.5927 11.9364 18.4595C11.7955 18.318 11.6835 18.1556 11.6006 17.9724C11.5177 17.7809 11.4762 17.5811 11.4762 17.3729C11.4762 17.1647 11.5177 16.9691 11.6006 16.7859C11.6835 16.5943 11.7913 16.432 11.924 16.2988C12.065 16.1572 12.2267 16.0489 12.4091 15.974C12.5998 15.8908 12.7989 15.8491 13.0062 15.8491Z" />
      </mask>
      <path
        d="M13.0062 15.8491C13.2135 15.8491 13.4084 15.8908 13.5908 15.974C13.7816 16.0489 13.9432 16.1572 14.0759 16.2988C14.2169 16.432 14.3247 16.5943 14.3993 16.7859C14.4823 16.9691 14.5237 17.1647 14.5237 17.3729C14.5237 17.5728 14.4823 17.7643 14.3993 17.9475C14.3247 18.1306 14.2169 18.293 14.0759 18.4346C13.9432 18.5761 13.7816 18.6885 13.5908 18.7718C13.4084 18.8551 13.2135 18.8967 13.0062 18.8967C12.8072 18.8967 12.6123 18.8551 12.4216 18.7718C12.2391 18.6968 12.0774 18.5927 11.9364 18.4595C11.7955 18.318 11.6835 18.1556 11.6006 17.9724C11.5177 17.7809 11.4762 17.5811 11.4762 17.3729C11.4762 17.1647 11.5177 16.9691 11.6006 16.7859C11.6835 16.5943 11.7913 16.432 11.924 16.2988C12.065 16.1572 12.2267 16.0489 12.4091 15.974C12.5998 15.8908 12.7989 15.8491 13.0062 15.8491Z"
        fill="#D64949"
        stroke="#D64949"
        strokeWidth="5.33316"
        mask="url(#path-3-inside-1_8906_6077)"
      />
    </SvgIconComponent>
  )
}

export function TaskStatusDone ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z"
        fill="white"
        fillRule="evenodd"
        stroke="#91D656"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M8.5 13.3125L11.5386 16.4063L17.5 10.5"
        stroke="#91D656"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SvgIconComponent>
  )
}

export function TaskStatusReject ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z"
        fill="white"
        fillRule="evenodd"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <g clipPath="url(#clip0_8906_3102)">
        <path
          d="M17.5 8.5L8.5 17.5"
          stroke="#D64949"
          strokeLinecap="round"
          strokeWidth="2"
        />
        <path
          d="M8.5 8.5L17.5 17.5"
          stroke="#D64949"
          strokeLinecap="round"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_8906_3102">
          <rect
            height="12"
            width="12"
            fill="white"
            transform="translate(7 7)"
          />
        </clipPath>
      </defs>
    </SvgIconComponent>
  )
}

export function TaskStatusClosed ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={25}
      height={24}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z"
        fill="#4D8CE8"
      />
      <path
        d="M8 12.3125L11.0386 15.4063L17 9.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIconComponent>
  )
}

export function TaskStatusInactive ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="#BEBEC7"
        fillRule="evenodd"
      />
      <path
        d="M7.5 12.3125L10.5386 15.4063L16.5 9.5"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </SvgIconComponent>
  )
}

export function TaskDateGray50 ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M22.5 2.5H4.5C2.84315 2.5 1.5 3.84315 1.5 5.5V22C1.5 23.6569 2.84315 25 4.5 25H22.5C24.1569 25 25.5 23.6569 25.5 22V5.5C25.5 3.84315 24.1569 2.5 22.5 2.5Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M16.99 1V4"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M12.75 1V4"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M8.51001 1V4"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M4.26953 1V4"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M21.2305 1V4"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 10.572C8.77238 10.572 9.572 9.77238 9.572 8.786C9.572 7.79962 8.77238 7 7.786 7C6.79962 7 6 7.79962 6 8.786C6 9.77238 6.79962 10.572 7.786 10.572Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 21.9997C14.4872 21.9997 15.2868 21.2001 15.2868 20.2137C15.2868 19.2274 14.4872 18.4277 13.5008 18.4277C12.5145 18.4277 11.7148 19.2274 11.7148 20.2137C11.7148 21.2001 12.5145 21.9997 13.5008 21.9997Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 21.9997C8.77238 21.9997 9.572 21.2001 9.572 20.2137C9.572 19.2274 8.77238 18.4277 7.786 18.4277C6.79962 18.4277 6 19.2274 6 20.2137C6 21.2001 6.79962 21.9997 7.786 21.9997Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M19.2137 16.2859C20.2001 16.2859 20.9997 15.4862 20.9997 14.4999C20.9997 13.5135 20.2001 12.7139 19.2137 12.7139C18.2274 12.7139 17.4277 13.5135 17.4277 14.4999C17.4277 15.4862 18.2274 16.2859 19.2137 16.2859Z"
        fill="#A0A0AA"
        stroke="#A0A0AA"
        strokeMiterlimit="10"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 16.2859C14.4872 16.2859 15.2868 15.4862 15.2868 14.4999C15.2868 13.5135 14.4872 12.7139 13.5008 12.7139C12.5145 12.7139 11.7148 13.5135 11.7148 14.4999C11.7148 15.4862 12.5145 16.2859 13.5008 16.2859Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 16.2859C8.77238 16.2859 9.572 15.4862 9.572 14.4999C9.572 13.5135 8.77238 12.7139 7.786 12.7139C6.79962 12.7139 6 13.5135 6 14.4999C6 15.4862 6.79962 16.2859 7.786 16.2859Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 10.572C14.4872 10.572 15.2868 9.77238 15.2868 8.786C15.2868 7.79962 14.4872 7 13.5008 7C12.5145 7 11.7148 7.79962 11.7148 8.786C11.7148 9.77238 12.5145 10.572 13.5008 10.572Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M19.2137 10.572C20.2001 10.572 20.9997 9.77238 20.9997 8.786C20.9997 7.79962 20.2001 7 19.2137 7C18.2274 7 17.4277 7.79962 17.4277 8.786C17.4277 9.77238 18.2274 10.572 19.2137 10.572Z"
        stroke="#A0A0AA"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function TaskDateGray70 ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M22.5 2.5H4.5C2.84315 2.5 1.5 3.84315 1.5 5.5V22C1.5 23.6569 2.84315 25 4.5 25H22.5C24.1569 25 25.5 23.6569 25.5 22V5.5C25.5 3.84315 24.1569 2.5 22.5 2.5Z"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M16.99 1V4"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M12.75 1V4"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M8.51001 1V4"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M4.26953 1V4"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M21.2305 1V4"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 10.572C8.77238 10.572 9.572 9.77238 9.572 8.786C9.572 7.79962 8.77238 7 7.786 7C6.79962 7 6 7.79962 6 8.786C6 9.77238 6.79962 10.572 7.786 10.572Z"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 22.0002C14.4872 22.0002 15.2868 21.2006 15.2868 20.2142C15.2868 19.2278 14.4872 18.4282 13.5008 18.4282C12.5145 18.4282 11.7148 19.2278 11.7148 20.2142C11.7148 21.2006 12.5145 22.0002 13.5008 22.0002Z"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 22C8.77238 22 9.572 21.2004 9.572 20.214C9.572 19.2276 8.77238 18.428 7.786 18.428C6.79962 18.428 6 19.2276 6 20.214C6 21.2004 6.79962 22 7.786 22Z"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M19.2137 16.2859C20.2001 16.2859 20.9997 15.4862 20.9997 14.4999C20.9997 13.5135 20.2001 12.7139 19.2137 12.7139C18.2274 12.7139 17.4277 13.5135 17.4277 14.4999C17.4277 15.4862 18.2274 16.2859 19.2137 16.2859Z"
        fill="#5F616E"
        stroke="#5F616E"
        strokeMiterlimit="10"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 16.2859C14.4872 16.2859 15.2868 15.4862 15.2868 14.4999C15.2868 13.5135 14.4872 12.7139 13.5008 12.7139C12.5145 12.7139 11.7148 13.5135 11.7148 14.4999C11.7148 15.4862 12.5145 16.2859 13.5008 16.2859Z"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 16.2859C8.77238 16.2859 9.572 15.4862 9.572 14.4999C9.572 13.5135 8.77238 12.7139 7.786 12.7139C6.79962 12.7139 6 13.5135 6 14.4999C6 15.4862 6.79962 16.2859 7.786 16.2859Z"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 10.572C14.4872 10.572 15.2868 9.77238 15.2868 8.786C15.2868 7.79962 14.4872 7 13.5008 7C12.5145 7 11.7148 7.79962 11.7148 8.786C11.7148 9.77238 12.5145 10.572 13.5008 10.572Z"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M19.2137 10.572C20.2001 10.572 20.9997 9.77238 20.9997 8.786C20.9997 7.79962 20.2001 7 19.2137 7C18.2274 7 17.4277 7.79962 17.4277 8.786C17.4277 9.77238 18.2274 10.572 19.2137 10.572Z"
        stroke="#5F616E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

export function TaskDateGray100 ({ size, ...props }) {
  return (
  <SvgIconComponent
    width={27}
    height={26}
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    size={size}
  >
    <path
      d="M22.5 2.5H4.5C2.84315 2.5 1.5 3.84315 1.5 5.5V22C1.5 23.6569 2.84315 25 4.5 25H22.5C24.1569 25 25.5 23.6569 25.5 22V5.5C25.5 3.84315 24.1569 2.5 22.5 2.5Z"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.99 1V4"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 1V4"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.51001 1V4"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.26953 1V4"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.2305 1V4"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.786 10.572C8.77238 10.572 9.572 9.77238 9.572 8.786C9.572 7.79962 8.77238 7 7.786 7C6.79962 7 6 7.79962 6 8.786C6 9.77238 6.79962 10.572 7.786 10.572Z"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5008 22.0002C14.4872 22.0002 15.2868 21.2006 15.2868 20.2142C15.2868 19.2278 14.4872 18.4282 13.5008 18.4282C12.5145 18.4282 11.7148 19.2278 11.7148 20.2142C11.7148 21.2006 12.5145 22.0002 13.5008 22.0002Z"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.786 22C8.77238 22 9.572 21.2004 9.572 20.214C9.572 19.2276 8.77238 18.428 7.786 18.428C6.79962 18.428 6 19.2276 6 20.214C6 21.2004 6.79962 22 7.786 22Z"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2137 16.2859C20.2001 16.2859 20.9997 15.4862 20.9997 14.4999C20.9997 13.5135 20.2001 12.7139 19.2137 12.7139C18.2274 12.7139 17.4277 13.5135 17.4277 14.4999C17.4277 15.4862 18.2274 16.2859 19.2137 16.2859Z"
      fill="#141A21"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeMiterlimit="10"
    />
    <path
      d="M13.5008 16.2859C14.4872 16.2859 15.2868 15.4862 15.2868 14.4999C15.2868 13.5135 14.4872 12.7139 13.5008 12.7139C12.5145 12.7139 11.7148 13.5135 11.7148 14.4999C11.7148 15.4862 12.5145 16.2859 13.5008 16.2859Z"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.786 16.2859C8.77238 16.2859 9.572 15.4862 9.572 14.4999C9.572 13.5135 8.77238 12.7139 7.786 12.7139C6.79962 12.7139 6 13.5135 6 14.4999C6 15.4862 6.79962 16.2859 7.786 16.2859Z"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.5008 10.572C14.4872 10.572 15.2868 9.77238 15.2868 8.786C15.2868 7.79962 14.4872 7 13.5008 7C12.5145 7 11.7148 7.79962 11.7148 8.786C11.7148 9.77238 12.5145 10.572 13.5008 10.572Z"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.2137 10.572C20.2001 10.572 20.9997 9.77238 20.9997 8.786C20.9997 7.79962 20.2001 7 19.2137 7C18.2274 7 17.4277 7.79962 17.4277 8.786C17.4277 9.77238 18.2274 10.572 19.2137 10.572Z"
      stroke="#141A21"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIconComponent>
  )
}

export function TaskDateSemanticError ({ size, ...props }) {
  return (
    <SvgIconComponent
      width={27}
      height={26}
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      size={size}
    >
      <path
        d="M22.5 2.5H4.5C2.84315 2.5 1.5 3.84315 1.5 5.5V22C1.5 23.6569 2.84315 25 4.5 25H22.5C24.1569 25 25.5 23.6569 25.5 22V5.5C25.5 3.84315 24.1569 2.5 22.5 2.5Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M16.99 1V4"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M12.75 1V4"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M8.51001 1V4"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M4.26953 1V4"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M21.2305 1V4"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 10.572C8.77238 10.572 9.572 9.77238 9.572 8.786C9.572 7.79962 8.77238 7 7.786 7C6.79962 7 6 7.79962 6 8.786C6 9.77238 6.79962 10.572 7.786 10.572Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 22.0002C14.4872 22.0002 15.2868 21.2006 15.2868 20.2142C15.2868 19.2278 14.4872 18.4282 13.5008 18.4282C12.5145 18.4282 11.7148 19.2278 11.7148 20.2142C11.7148 21.2006 12.5145 22.0002 13.5008 22.0002Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 22C8.77238 22 9.572 21.2004 9.572 20.214C9.572 19.2276 8.77238 18.428 7.786 18.428C6.79962 18.428 6 19.2276 6 20.214C6 21.2004 6.79962 22 7.786 22Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M19.2137 16.2859C20.2001 16.2859 20.9997 15.4862 20.9997 14.4999C20.9997 13.5135 20.2001 12.7139 19.2137 12.7139C18.2274 12.7139 17.4277 13.5135 17.4277 14.4999C17.4277 15.4862 18.2274 16.2859 19.2137 16.2859Z"
        fill="#D64949"
        stroke="#D64949"
        strokeMiterlimit="10"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 16.2859C14.4872 16.2859 15.2868 15.4862 15.2868 14.4999C15.2868 13.5135 14.4872 12.7139 13.5008 12.7139C12.5145 12.7139 11.7148 13.5135 11.7148 14.4999C11.7148 15.4862 12.5145 16.2859 13.5008 16.2859Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M7.786 16.2859C8.77238 16.2859 9.572 15.4862 9.572 14.4999C9.572 13.5135 8.77238 12.7139 7.786 12.7139C6.79962 12.7139 6 13.5135 6 14.4999C6 15.4862 6.79962 16.2859 7.786 16.2859Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M13.5008 10.572C14.4872 10.572 15.2868 9.77238 15.2868 8.786C15.2868 7.79962 14.4872 7 13.5008 7C12.5145 7 11.7148 7.79962 11.7148 8.786C11.7148 9.77238 12.5145 10.572 13.5008 10.572Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
      <path
        d="M19.2137 10.572C20.2001 10.572 20.9997 9.77238 20.9997 8.786C20.9997 7.79962 20.2001 7 19.2137 7C18.2274 7 17.4277 7.79962 17.4277 8.786C17.4277 9.77238 18.2274 10.572 19.2137 10.572Z"
        stroke="#D64949"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </SvgIconComponent>
  )
}

const iconPropTypes = {
  size: PropTypes.oneOf(Object.keys(iconSizes))
}
TaskStatusOpen.propTypes = iconPropTypes
TaskStatusOpenOverdue.propTypes = iconPropTypes
TaskStatusDone.propTypes = iconPropTypes
TaskStatusReject.propTypes = iconPropTypes
TaskStatusClosed.propTypes = iconPropTypes
TaskStatusInactive.propTypes = iconPropTypes
TaskDateGray50.propTypes = iconPropTypes
TaskDateGray70.propTypes = iconPropTypes
TaskDateGray100.propTypes = iconPropTypes
TaskDateSemanticError.propTypes = iconPropTypes

const iconsTaskPreview = {
  TaskStatusOpen,
  TaskStatusOpenOverdue,
  TaskStatusDone,
  TaskStatusReject,
  TaskStatusClosed,
  TaskStatusInactive,
  TaskDateGray50,
  TaskDateGray70,
  TaskDateGray100,
  TaskDateSemanticError
}

export default iconsTaskPreview
